<template>
	<ClientOnly>
		<v-bottom-sheet v-if="isModalPossibleToOpen" v-model="isDeliveryCarModalOpen" content-class="booker-delivery-sheet" :style="`z-index: 2100;`">
			<v-card>
				<GlobalBookerDeliveryCarSummary :type="type" />
			</v-card>
		</v-bottom-sheet>
	</ClientOnly>
</template>

<script lang="ts" setup>
import { EBookerLocationType } from '@/data/bookerData'
const bookerState = inject<Ref<IBookerState>>('bookerState')!
const isDeliveryCarModalOpen = inject<Ref<boolean>>('isDeliveryCarModalOpen')!
const props = defineProps<{
	type: EBookerLocationType
}>()

const isModalPossibleToOpen = computed(() => {
	return (
		(props.type === EBookerLocationType.START && bookerState.value.isStartLocationMenuOpen) ||
		(props.type === EBookerLocationType.END && bookerState.value.isEndLocationMenuOpen)
	)
})
</script>

<style lang="scss">
@import './Modal';
</style>
